import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { GLOBAL_ERROR_CODE } from 'api/status'
import OcrReaderLogo from 'assets/images/logoSl.svg'
import E404 from 'components/404Error'
import IPError from 'components/IPError'
import { HTTP_STATUS, LINK_SUPPORT } from 'config'
import { useConfirm } from 'hooks/useDialog'
import useLogout from 'hooks/useLogout'
import { useLayoutEffect } from 'react'
import { useRouteError } from 'react-router-dom'
import { getErrorStatus } from 'utils/errorsUtil'

const TRIAL_END_MSG = [
  'OCR Readerトライアルをご利用いただきありがとうございました。',
  'ご意見・ご要望や継続利用についてはこちらよりご連絡ください',
]

function TrialEnded() {
  const confirm = useConfirm()
  const { logout } = useLogout()

  useLayoutEffect(() => {
    confirm({
      message: TRIAL_END_MSG,
      actionText: 'お問い合わせ',
      cancelText: '閉じる',
      onConfirm: () => {
        location.assign(LINK_SUPPORT)
      },
      onCancel: () => {
        logout()
      },
    })
  }, [confirm, logout])

  return null
}

const Error = () => {
  const error = useRouteError() as any
  const { logout } = useLogout()
  const status = getErrorStatus(error)
  if (status === HTTP_STATUS.NOT_FOUND) {
    return <E404 />
  }
  if (status === HTTP_STATUS.FORBIDDEN) {
    if (GLOBAL_ERROR_CODE.TRAIL_ENDED === error.response.data?.status) {
      return <TrialEnded />
    }
    if (GLOBAL_ERROR_CODE.IP_RESTRICTION === error.response.data?.status) {
      return <IPError />
    }
  }

  error && console.error(error)
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      sx={{
        backgroundColor: 'grey.200',
        height: '100%',
      }}
    >
      <img style={{ margin: '16px auto' }} width="220px" src={OcrReaderLogo} alt="logo" />
      <Typography variant="h6" style={{ color: 'red' }}>
        エラーが発生しました。
      </Typography>
      <p>{error?.statusText || error?.message}</p>
      <div>
        <button type="button" onClick={logout}>
          ログイン画面に戻る
        </button>
      </div>
    </Stack>
  )
}

export default Error
